import gql from "graphql-tag";

const getAppConfigOrganization = gql`
  query {
    getAppConfigOrganization {
      id
      logoUrl
      shortName
      name
      slogan
      address
      phone
      createdAt
      updatedAt
    }
  }
`;

const createAppConfigOrganization = gql`
  mutation(
    $logoUrl: String
    $shortName: String
    $name: String
    $slogan: String
    $address: String
    $phone: String
  ) {
    createAppConfigOrganization(
      data: {
        logoUrl: $logoUrl
        shortName: $shortName
        name: $name
        slogan: $slogan
        address: $address
        phone: $phone
      }
    ) {
      id
      name
      logoUrl
      shortName
      slogan
      address
      phone
      createdAt
      updatedAt
    }
  }
`;

const updateAppConfigOrganization = gql`
  mutation(
    $logoUrl: String
    $shortName: String
    $name: String
    $slogan: String
    $address: String
    $phone: String
  ) {
    updateAppConfigOrganization(
      data: {
        logoUrl: $logoUrl
        shortName: $shortName
        name: $name
        slogan: $slogan
        address: $address
        phone: $phone
      }
    ) {
      id
      name
      logoUrl
      shortName
      slogan
      address
      phone
      createdAt
      updatedAt
    }
  }
`;

// app

const createAppInPlatform = gql`
  mutation(
    $url: String!
    $iconUrl: String!
    $name: String!
    $description: String
    $openNewTab: Boolean
    $userCanAccessIds: [ID!]
    $isV1: Boolean
    $isV2: Boolean
    $numberOrder: Float
  ) {
    createAppInPlatform(
      data: {
        url: $url
        iconUrl: $iconUrl
        name: $name
        description: $description
        openNewTab: $openNewTab
        userCanAccessIds: $userCanAccessIds
        isV1: $isV1
        isV2: $isV2
        numberOrder: $numberOrder
      }
    ) {
      id
      name
      url
      iconUrl
      description
      openNewTab
      isV1
      isV2
      numberOrder
      isPublishedToAllUser
      userCanAccess {
        id
        username
        fullname
        email
      }
      createdAt
      updatedAt
    }
  }
`;

const updateAppInPlatform = gql`
  mutation(
    $id: ID!
    $url: String!
    $iconUrl: String!
    $name: String!
    $description: String
    $openNewTab: Boolean
    $userCanAccessIds: [ID!]
    $isPublishedToAllUser: Boolean
    $groupId: ID
    $isV1: Boolean
    $isV2: Boolean
    $numberOrder: Float
  ) {
    updateAppInPlatform(
      id: $id
      data: {
        url: $url
        iconUrl: $iconUrl
        name: $name
        description: $description
        openNewTab: $openNewTab
        userCanAccessIds: $userCanAccessIds
        isPublishedToAllUser: $isPublishedToAllUser
        groupId: $groupId
        isV1: $isV1
        isV2: $isV2
        numberOrder: $numberOrder
      }
    ) {
      id
      name
      url
      iconUrl
      description
      openNewTab
      isPublishedToAllUser
      groupId
      isV1
      isV2
      numberOrder
      userCanAccess {
        id
        username
        fullname
        email
      }
      createdAt
      updatedAt
    }
  }
`;

const getAppInPlatform = gql`
  query($id: ID!) {
    getAppInPlatform(id: $id) {
      id
      url
      iconUrl
      name
      description
      openNewTab
      isPublishedToAllUser
      groupId
      isV1
      isV2
      numberOrder
      userCanAccess {
        id
        username
        fullname
        email
      }
      excludeUsers {
        id
        username
        fullname
        email
      }
      createdAt
      updatedAt
    }
  }
`;

const getAllAppInPlatform = gql`
  query {
    getAllAppInPlatform {
      id
      url
      iconUrl
      name
      description
      openNewTab
      isPublishedToAllUser
      groupId
      isV1
      isV2
      numberOrder
      userCanAccess {
        id
        username
        fullname
        email
      }
      createdAt
      updatedAt
    }
  }
`;

const deleteAppInPlatform = gql`
  mutation($id: ID!) {
    deleteAppInPlatform(id: $id) {
      id
    }
  }
`;

const users = gql`
  query($query: String, $departmentIds: [ID!]) {
    users(query: $query, filter: { departmentIds: $departmentIds }) {
      id
      fullname
      username
      email
    }
  }
`;

const assignUsersToAppInPlatform = gql`
  mutation($id: ID!, $userIds: [ID!]!) {
    assignUsersToAppInPlatform(id: $id, userIds: $userIds) {
      id
      userCanAccess {
        id
        username
        fullname
        email
      }
    }
  }
`;

const unAssignUsersToAppInPlatform = gql`
  mutation($id: ID!, $userIds: [ID!]!) {
    unAssignUsersToAppInPlatform(id: $id, userIds: $userIds) {
      id
      userCanAccess {
        id
        username
        fullname
        email
      }
    }
  }
`;

const addExcludeUsersToAppInPlatform = gql`
  mutation($id: ID!, $userIds: [ID!]!) {
    addExcludeUsersToAppInPlatform(id: $id, userIds: $userIds) {
      id
      excludeUsers {
        id
        username
        fullname
        email
      }
    }
  }
`;

const removeExcludeUsersToAppInPlatform = gql`
  mutation($id: ID!, $userIds: [ID!]!) {
    removeExcludeUsersToAppInPlatform(id: $id, userIds: $userIds) {
      id
      excludeUsers {
        id
        username
        fullname
        email
      }
    }
  }
`;

export default {
  getAppConfigOrganization,
  createAppConfigOrganization,
  updateAppConfigOrganization,
  createAppInPlatform,
  updateAppInPlatform,
  getAppInPlatform,
  getAllAppInPlatform,
  deleteAppInPlatform,
  users,
  assignUsersToAppInPlatform,
  unAssignUsersToAppInPlatform,
  addExcludeUsersToAppInPlatform,
  removeExcludeUsersToAppInPlatform,
};
